//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './PermissionsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type PermissionsGetPermissionsQueryParameters = {
  providerName?: string | undefined ;
  providerKey?: string | undefined ;
}

export type PermissionsUpdatePermissionsQueryParameters = {
  providerName?: string | undefined ;
  providerKey?: string | undefined ;
}

export type PermissionsGetByGroupPermissionsQueryParameters = {
  groupName?: string | undefined ;
  providerName?: string | undefined ;
  providerKey?: string | undefined ;
}

export type PermissionsGetResourceProviderKeyLookupServicesPermissionsQueryParameters = {
  resourceName?: string | undefined ;
}

export type PermissionsSearchResourceProviderKeyPermissionsQueryParameters = {
  resourceName?: string | undefined ;
  serviceName?: string | undefined ;
  filter?: string | undefined ;
  page?: number | undefined ;
}

export type PermissionsGetResourceDefinitionsPermissionsQueryParameters = {
  resourceName?: string | undefined ;
}

export type PermissionsGetResourcePermissionsQueryParameters = {
  resourceName?: string | undefined ;
  resourceKey?: string | undefined ;
}

export type PermissionsUpdateResourcePermissionsQueryParameters = {
  resourceName?: string | undefined ;
  resourceKey?: string | undefined ;
}

export type PermissionsDeleteResourcePermissionsQueryParameters = {
  resourceName?: string | undefined ;
  resourceKey?: string | undefined ;
  providerName?: string | undefined ;
  providerKey?: string | undefined ;
}

export type PermissionsGetResourceByProviderPermissionsQueryParameters = {
  resourceName?: string | undefined ;
  resourceKey?: string | undefined ;
  providerName?: string | undefined ;
  providerKey?: string | undefined ;
}

export function permissionsGetUrl(providerName?: string | undefined, providerKey?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/permission-management/permissions?";
if (providerName === null)
    throw new Error("The parameter 'providerName' cannot be null.");
else if (providerName !== undefined)
    url_ += "providerName=" + encodeURIComponent("" + providerName) + "&";
if (providerKey === null)
    throw new Error("The parameter 'providerKey' cannot be null.");
else if (providerKey !== undefined)
    url_ += "providerKey=" + encodeURIComponent("" + providerKey) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let permissionsGetDefaultOptions: Omit<UseQueryOptions<Types.GetPermissionListResultDto, unknown, Types.GetPermissionListResultDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetPermissionListResultDto, unknown, Types.GetPermissionListResultDto>, 'queryFn'>> = {
};
export function getPermissionsGetDefaultOptions() {
  return permissionsGetDefaultOptions;
};
export function setPermissionsGetDefaultOptions(options: typeof permissionsGetDefaultOptions) {
  permissionsGetDefaultOptions = options;
}

export function permissionsGetQueryKey(dto: PermissionsGetPermissionsQueryParameters): QueryKey;
export function permissionsGetQueryKey(providerName?: string | undefined, providerKey?: string | undefined): QueryKey;
export function permissionsGetQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { providerName, providerKey,  } = params[0] as PermissionsGetPermissionsQueryParameters;

    return trimArrayEnd([
        'PermissionsClient',
        'permissionsGet',
        providerName as any,
        providerKey as any,
      ]);
  } else {
    return trimArrayEnd([
        'PermissionsClient',
        'permissionsGet',
        ...params
      ]);
  }
}
export function __permissionsGet(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.permissionsGet(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as string | undefined,axiosConfig    );
}

export function usePermissionsGetQuery<TSelectData = Types.GetPermissionListResultDto, TError = unknown>(dto: PermissionsGetPermissionsQueryParameters, options?: Omit<UseQueryOptions<Types.GetPermissionListResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @return OK
 */
export function usePermissionsGetQuery<TSelectData = Types.GetPermissionListResultDto, TError = unknown>(providerName?: string | undefined, providerKey?: string | undefined, options?: Omit<UseQueryOptions<Types.GetPermissionListResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function usePermissionsGetQuery<TSelectData = Types.GetPermissionListResultDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetPermissionListResultDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let providerName: any = undefined;
  let providerKey: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ providerName, providerKey,  } = params[0] as PermissionsGetPermissionsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [providerName, providerKey, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetPermissionListResultDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __permissionsGet(context, axiosConfig) : __permissionsGet,
    queryKey: permissionsGetQueryKey(providerName, providerKey),
    ...permissionsGetDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetPermissionListResultDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @return OK
 */
export function setPermissionsGetData(queryClient: QueryClient, updater: (data: Types.GetPermissionListResultDto | undefined) => Types.GetPermissionListResultDto, providerName?: string | undefined, providerKey?: string | undefined) {
  queryClient.setQueryData(permissionsGetQueryKey(providerName, providerKey),
    updater
  );
}

/**
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @return OK
 */
export function setPermissionsGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetPermissionListResultDto | undefined) => Types.GetPermissionListResultDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function permissionsUpdateUrl(providerName?: string | undefined, providerKey?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/permission-management/permissions?";
if (providerName === null)
    throw new Error("The parameter 'providerName' cannot be null.");
else if (providerName !== undefined)
    url_ += "providerName=" + encodeURIComponent("" + providerName) + "&";
if (providerKey === null)
    throw new Error("The parameter 'providerKey' cannot be null.");
else if (providerKey !== undefined)
    url_ += "providerKey=" + encodeURIComponent("" + providerKey) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function permissionsUpdateMutationKey(providerName?: string | undefined, providerKey?: string | undefined): MutationKey {
  return trimArrayEnd([
      'PermissionsClient',
      'permissionsUpdate',
      providerName as any,
      providerKey as any,
    ]);
}

/**
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @param body (optional) 
 * @return OK
 */
export function usePermissionsUpdateMutation<TContext>(providerName?: string | undefined, providerKey?: string | undefined, options?: Omit<UseMutationOptions<void, unknown, Types.UpdatePermissionsDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.UpdatePermissionsDto, TContext> {
  const key = permissionsUpdateMutationKey(providerName, providerKey);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.UpdatePermissionsDto) => Client.permissionsUpdate(providerName, providerKey, body),
    mutationKey: key,
  });
}
  
type PermissionsUpdate__MutationParameters = PermissionsUpdatePermissionsQueryParameters & {
  body: Types.UpdatePermissionsDto;
}

/**
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @param body (optional) 
 * @return OK
 */
export function usePermissionsUpdateMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, PermissionsUpdate__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PermissionsUpdatePermissionsQueryParameters}): UseMutationResult<void, unknown, PermissionsUpdate__MutationParameters, TContext> {
  const key = permissionsUpdateMutationKey(options?.parameters?.providerName!, options?.parameters?.providerKey!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PermissionsUpdate__MutationParameters) => Client.permissionsUpdate(data.providerName ?? options?.parameters?.providerName!, data.providerKey ?? options?.parameters?.providerKey!, data.body),
  mutationKey: key,
});
}
  
export function permissionsGetByGroupUrl(groupName?: string | undefined, providerName?: string | undefined, providerKey?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/permission-management/permissions/by-group?";
if (groupName === null)
    throw new Error("The parameter 'groupName' cannot be null.");
else if (groupName !== undefined)
    url_ += "groupName=" + encodeURIComponent("" + groupName) + "&";
if (providerName === null)
    throw new Error("The parameter 'providerName' cannot be null.");
else if (providerName !== undefined)
    url_ += "providerName=" + encodeURIComponent("" + providerName) + "&";
if (providerKey === null)
    throw new Error("The parameter 'providerKey' cannot be null.");
else if (providerKey !== undefined)
    url_ += "providerKey=" + encodeURIComponent("" + providerKey) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let permissionsGetByGroupDefaultOptions: Omit<UseQueryOptions<Types.GetPermissionListResultDto, unknown, Types.GetPermissionListResultDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetPermissionListResultDto, unknown, Types.GetPermissionListResultDto>, 'queryFn'>> = {
};
export function getPermissionsGetByGroupDefaultOptions() {
  return permissionsGetByGroupDefaultOptions;
};
export function setPermissionsGetByGroupDefaultOptions(options: typeof permissionsGetByGroupDefaultOptions) {
  permissionsGetByGroupDefaultOptions = options;
}

export function permissionsGetByGroupQueryKey(dto: PermissionsGetByGroupPermissionsQueryParameters): QueryKey;
export function permissionsGetByGroupQueryKey(groupName?: string | undefined, providerName?: string | undefined, providerKey?: string | undefined): QueryKey;
export function permissionsGetByGroupQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { groupName, providerName, providerKey,  } = params[0] as PermissionsGetByGroupPermissionsQueryParameters;

    return trimArrayEnd([
        'PermissionsClient',
        'permissionsGetByGroup',
        groupName as any,
        providerName as any,
        providerKey as any,
      ]);
  } else {
    return trimArrayEnd([
        'PermissionsClient',
        'permissionsGetByGroup',
        ...params
      ]);
  }
}
export function __permissionsGetByGroup(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.permissionsGetByGroup(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as string | undefined,       context.queryKey[4] as string | undefined,axiosConfig    );
}

export function usePermissionsGetByGroupQuery<TSelectData = Types.GetPermissionListResultDto, TError = unknown>(dto: PermissionsGetByGroupPermissionsQueryParameters, options?: Omit<UseQueryOptions<Types.GetPermissionListResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param groupName (optional) 
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @return OK
 */
export function usePermissionsGetByGroupQuery<TSelectData = Types.GetPermissionListResultDto, TError = unknown>(groupName?: string | undefined, providerName?: string | undefined, providerKey?: string | undefined, options?: Omit<UseQueryOptions<Types.GetPermissionListResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function usePermissionsGetByGroupQuery<TSelectData = Types.GetPermissionListResultDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetPermissionListResultDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let groupName: any = undefined;
  let providerName: any = undefined;
  let providerKey: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ groupName, providerName, providerKey,  } = params[0] as PermissionsGetByGroupPermissionsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [groupName, providerName, providerKey, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetPermissionListResultDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __permissionsGetByGroup(context, axiosConfig) : __permissionsGetByGroup,
    queryKey: permissionsGetByGroupQueryKey(groupName, providerName, providerKey),
    ...permissionsGetByGroupDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetPermissionListResultDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param groupName (optional) 
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @return OK
 */
export function setPermissionsGetByGroupData(queryClient: QueryClient, updater: (data: Types.GetPermissionListResultDto | undefined) => Types.GetPermissionListResultDto, groupName?: string | undefined, providerName?: string | undefined, providerKey?: string | undefined) {
  queryClient.setQueryData(permissionsGetByGroupQueryKey(groupName, providerName, providerKey),
    updater
  );
}

/**
 * @param groupName (optional) 
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @return OK
 */
export function setPermissionsGetByGroupDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetPermissionListResultDto | undefined) => Types.GetPermissionListResultDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function permissionsGetResourceProviderKeyLookupServicesUrl(resourceName?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/permission-management/permissions/resource-provider-key-lookup-services?";
if (resourceName === null)
    throw new Error("The parameter 'resourceName' cannot be null.");
else if (resourceName !== undefined)
    url_ += "resourceName=" + encodeURIComponent("" + resourceName) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let permissionsGetResourceProviderKeyLookupServicesDefaultOptions: Omit<UseQueryOptions<Types.GetResourceProviderListResultDto, unknown, Types.GetResourceProviderListResultDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetResourceProviderListResultDto, unknown, Types.GetResourceProviderListResultDto>, 'queryFn'>> = {
};
export function getPermissionsGetResourceProviderKeyLookupServicesDefaultOptions() {
  return permissionsGetResourceProviderKeyLookupServicesDefaultOptions;
};
export function setPermissionsGetResourceProviderKeyLookupServicesDefaultOptions(options: typeof permissionsGetResourceProviderKeyLookupServicesDefaultOptions) {
  permissionsGetResourceProviderKeyLookupServicesDefaultOptions = options;
}

export function permissionsGetResourceProviderKeyLookupServicesQueryKey(resourceName?: string | undefined): QueryKey;
export function permissionsGetResourceProviderKeyLookupServicesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { resourceName,  } = params[0] as PermissionsGetResourceProviderKeyLookupServicesPermissionsQueryParameters;

    return trimArrayEnd([
        'PermissionsClient',
        'permissionsGetResourceProviderKeyLookupServices',
        resourceName as any,
      ]);
  } else {
    return trimArrayEnd([
        'PermissionsClient',
        'permissionsGetResourceProviderKeyLookupServices',
        ...params
      ]);
  }
}
export function __permissionsGetResourceProviderKeyLookupServices(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.permissionsGetResourceProviderKeyLookupServices(
      context.queryKey[2] as string | undefined,axiosConfig    );
}

export function usePermissionsGetResourceProviderKeyLookupServicesQuery<TSelectData = Types.GetResourceProviderListResultDto, TError = unknown>(dto: PermissionsGetResourceProviderKeyLookupServicesPermissionsQueryParameters, options?: Omit<UseQueryOptions<Types.GetResourceProviderListResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param resourceName (optional) 
 * @return OK
 */
export function usePermissionsGetResourceProviderKeyLookupServicesQuery<TSelectData = Types.GetResourceProviderListResultDto, TError = unknown>(resourceName?: string | undefined, options?: Omit<UseQueryOptions<Types.GetResourceProviderListResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function usePermissionsGetResourceProviderKeyLookupServicesQuery<TSelectData = Types.GetResourceProviderListResultDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetResourceProviderListResultDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let resourceName: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ resourceName,  } = params[0] as PermissionsGetResourceProviderKeyLookupServicesPermissionsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [resourceName, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetResourceProviderListResultDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __permissionsGetResourceProviderKeyLookupServices(context, axiosConfig) : __permissionsGetResourceProviderKeyLookupServices,
    queryKey: permissionsGetResourceProviderKeyLookupServicesQueryKey(resourceName),
    ...permissionsGetResourceProviderKeyLookupServicesDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetResourceProviderListResultDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param resourceName (optional) 
 * @return OK
 */
export function setPermissionsGetResourceProviderKeyLookupServicesData(queryClient: QueryClient, updater: (data: Types.GetResourceProviderListResultDto | undefined) => Types.GetResourceProviderListResultDto, resourceName?: string | undefined) {
  queryClient.setQueryData(permissionsGetResourceProviderKeyLookupServicesQueryKey(resourceName),
    updater
  );
}

/**
 * @param resourceName (optional) 
 * @return OK
 */
export function setPermissionsGetResourceProviderKeyLookupServicesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetResourceProviderListResultDto | undefined) => Types.GetResourceProviderListResultDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function permissionsSearchResourceProviderKeyUrl(resourceName?: string | undefined, serviceName?: string | undefined, filter?: string | undefined, page?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/permission-management/permissions/search-resource-provider-keys?";
if (resourceName === null)
    throw new Error("The parameter 'resourceName' cannot be null.");
else if (resourceName !== undefined)
    url_ += "resourceName=" + encodeURIComponent("" + resourceName) + "&";
if (serviceName === null)
    throw new Error("The parameter 'serviceName' cannot be null.");
else if (serviceName !== undefined)
    url_ += "serviceName=" + encodeURIComponent("" + serviceName) + "&";
if (filter === null)
    throw new Error("The parameter 'filter' cannot be null.");
else if (filter !== undefined)
    url_ += "filter=" + encodeURIComponent("" + filter) + "&";
if (page === null)
    throw new Error("The parameter 'page' cannot be null.");
else if (page !== undefined)
    url_ += "page=" + encodeURIComponent("" + page) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let permissionsSearchResourceProviderKeyDefaultOptions: Omit<UseQueryOptions<Types.SearchProviderKeyListResultDto, unknown, Types.SearchProviderKeyListResultDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.SearchProviderKeyListResultDto, unknown, Types.SearchProviderKeyListResultDto>, 'queryFn'>> = {
};
export function getPermissionsSearchResourceProviderKeyDefaultOptions() {
  return permissionsSearchResourceProviderKeyDefaultOptions;
};
export function setPermissionsSearchResourceProviderKeyDefaultOptions(options: typeof permissionsSearchResourceProviderKeyDefaultOptions) {
  permissionsSearchResourceProviderKeyDefaultOptions = options;
}

export function permissionsSearchResourceProviderKeyQueryKey(dto: PermissionsSearchResourceProviderKeyPermissionsQueryParameters): QueryKey;
export function permissionsSearchResourceProviderKeyQueryKey(resourceName?: string | undefined, serviceName?: string | undefined, filter?: string | undefined, page?: number | undefined): QueryKey;
export function permissionsSearchResourceProviderKeyQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { resourceName, serviceName, filter, page,  } = params[0] as PermissionsSearchResourceProviderKeyPermissionsQueryParameters;

    return trimArrayEnd([
        'PermissionsClient',
        'permissionsSearchResourceProviderKey',
        resourceName as any,
        serviceName as any,
        filter as any,
        page as any,
      ]);
  } else {
    return trimArrayEnd([
        'PermissionsClient',
        'permissionsSearchResourceProviderKey',
        ...params
      ]);
  }
}
export function __permissionsSearchResourceProviderKey(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.permissionsSearchResourceProviderKey(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as string | undefined,       context.queryKey[4] as string | undefined,       context.queryKey[5] as number | undefined,axiosConfig    );
}

export function usePermissionsSearchResourceProviderKeyQuery<TSelectData = Types.SearchProviderKeyListResultDto, TError = unknown>(dto: PermissionsSearchResourceProviderKeyPermissionsQueryParameters, options?: Omit<UseQueryOptions<Types.SearchProviderKeyListResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param resourceName (optional) 
 * @param serviceName (optional) 
 * @param filter (optional) 
 * @param page (optional) 
 * @return OK
 */
export function usePermissionsSearchResourceProviderKeyQuery<TSelectData = Types.SearchProviderKeyListResultDto, TError = unknown>(resourceName?: string | undefined, serviceName?: string | undefined, filter?: string | undefined, page?: number | undefined, options?: Omit<UseQueryOptions<Types.SearchProviderKeyListResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function usePermissionsSearchResourceProviderKeyQuery<TSelectData = Types.SearchProviderKeyListResultDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.SearchProviderKeyListResultDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let resourceName: any = undefined;
  let serviceName: any = undefined;
  let filter: any = undefined;
  let page: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ resourceName, serviceName, filter, page,  } = params[0] as PermissionsSearchResourceProviderKeyPermissionsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [resourceName, serviceName, filter, page, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.SearchProviderKeyListResultDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __permissionsSearchResourceProviderKey(context, axiosConfig) : __permissionsSearchResourceProviderKey,
    queryKey: permissionsSearchResourceProviderKeyQueryKey(resourceName, serviceName, filter, page),
    ...permissionsSearchResourceProviderKeyDefaultOptions as unknown as Omit<UseQueryOptions<Types.SearchProviderKeyListResultDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param resourceName (optional) 
 * @param serviceName (optional) 
 * @param filter (optional) 
 * @param page (optional) 
 * @return OK
 */
export function setPermissionsSearchResourceProviderKeyData(queryClient: QueryClient, updater: (data: Types.SearchProviderKeyListResultDto | undefined) => Types.SearchProviderKeyListResultDto, resourceName?: string | undefined, serviceName?: string | undefined, filter?: string | undefined, page?: number | undefined) {
  queryClient.setQueryData(permissionsSearchResourceProviderKeyQueryKey(resourceName, serviceName, filter, page),
    updater
  );
}

/**
 * @param resourceName (optional) 
 * @param serviceName (optional) 
 * @param filter (optional) 
 * @param page (optional) 
 * @return OK
 */
export function setPermissionsSearchResourceProviderKeyDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.SearchProviderKeyListResultDto | undefined) => Types.SearchProviderKeyListResultDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function permissionsGetResourceDefinitionsUrl(resourceName?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/permission-management/permissions/resource-definitions?";
if (resourceName === null)
    throw new Error("The parameter 'resourceName' cannot be null.");
else if (resourceName !== undefined)
    url_ += "resourceName=" + encodeURIComponent("" + resourceName) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let permissionsGetResourceDefinitionsDefaultOptions: Omit<UseQueryOptions<Types.GetResourcePermissionDefinitionListResultDto, unknown, Types.GetResourcePermissionDefinitionListResultDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetResourcePermissionDefinitionListResultDto, unknown, Types.GetResourcePermissionDefinitionListResultDto>, 'queryFn'>> = {
};
export function getPermissionsGetResourceDefinitionsDefaultOptions() {
  return permissionsGetResourceDefinitionsDefaultOptions;
};
export function setPermissionsGetResourceDefinitionsDefaultOptions(options: typeof permissionsGetResourceDefinitionsDefaultOptions) {
  permissionsGetResourceDefinitionsDefaultOptions = options;
}

export function permissionsGetResourceDefinitionsQueryKey(resourceName?: string | undefined): QueryKey;
export function permissionsGetResourceDefinitionsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { resourceName,  } = params[0] as PermissionsGetResourceDefinitionsPermissionsQueryParameters;

    return trimArrayEnd([
        'PermissionsClient',
        'permissionsGetResourceDefinitions',
        resourceName as any,
      ]);
  } else {
    return trimArrayEnd([
        'PermissionsClient',
        'permissionsGetResourceDefinitions',
        ...params
      ]);
  }
}
export function __permissionsGetResourceDefinitions(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.permissionsGetResourceDefinitions(
      context.queryKey[2] as string | undefined,axiosConfig    );
}

export function usePermissionsGetResourceDefinitionsQuery<TSelectData = Types.GetResourcePermissionDefinitionListResultDto, TError = unknown>(dto: PermissionsGetResourceDefinitionsPermissionsQueryParameters, options?: Omit<UseQueryOptions<Types.GetResourcePermissionDefinitionListResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param resourceName (optional) 
 * @return OK
 */
export function usePermissionsGetResourceDefinitionsQuery<TSelectData = Types.GetResourcePermissionDefinitionListResultDto, TError = unknown>(resourceName?: string | undefined, options?: Omit<UseQueryOptions<Types.GetResourcePermissionDefinitionListResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function usePermissionsGetResourceDefinitionsQuery<TSelectData = Types.GetResourcePermissionDefinitionListResultDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetResourcePermissionDefinitionListResultDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let resourceName: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ resourceName,  } = params[0] as PermissionsGetResourceDefinitionsPermissionsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [resourceName, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetResourcePermissionDefinitionListResultDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __permissionsGetResourceDefinitions(context, axiosConfig) : __permissionsGetResourceDefinitions,
    queryKey: permissionsGetResourceDefinitionsQueryKey(resourceName),
    ...permissionsGetResourceDefinitionsDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetResourcePermissionDefinitionListResultDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param resourceName (optional) 
 * @return OK
 */
export function setPermissionsGetResourceDefinitionsData(queryClient: QueryClient, updater: (data: Types.GetResourcePermissionDefinitionListResultDto | undefined) => Types.GetResourcePermissionDefinitionListResultDto, resourceName?: string | undefined) {
  queryClient.setQueryData(permissionsGetResourceDefinitionsQueryKey(resourceName),
    updater
  );
}

/**
 * @param resourceName (optional) 
 * @return OK
 */
export function setPermissionsGetResourceDefinitionsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetResourcePermissionDefinitionListResultDto | undefined) => Types.GetResourcePermissionDefinitionListResultDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function permissionsGetResourceUrl(resourceName?: string | undefined, resourceKey?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/permission-management/permissions/resource?";
if (resourceName === null)
    throw new Error("The parameter 'resourceName' cannot be null.");
else if (resourceName !== undefined)
    url_ += "resourceName=" + encodeURIComponent("" + resourceName) + "&";
if (resourceKey === null)
    throw new Error("The parameter 'resourceKey' cannot be null.");
else if (resourceKey !== undefined)
    url_ += "resourceKey=" + encodeURIComponent("" + resourceKey) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let permissionsGetResourceDefaultOptions: Omit<UseQueryOptions<Types.GetResourcePermissionListResultDto, unknown, Types.GetResourcePermissionListResultDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetResourcePermissionListResultDto, unknown, Types.GetResourcePermissionListResultDto>, 'queryFn'>> = {
};
export function getPermissionsGetResourceDefaultOptions() {
  return permissionsGetResourceDefaultOptions;
};
export function setPermissionsGetResourceDefaultOptions(options: typeof permissionsGetResourceDefaultOptions) {
  permissionsGetResourceDefaultOptions = options;
}

export function permissionsGetResourceQueryKey(dto: PermissionsGetResourcePermissionsQueryParameters): QueryKey;
export function permissionsGetResourceQueryKey(resourceName?: string | undefined, resourceKey?: string | undefined): QueryKey;
export function permissionsGetResourceQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { resourceName, resourceKey,  } = params[0] as PermissionsGetResourcePermissionsQueryParameters;

    return trimArrayEnd([
        'PermissionsClient',
        'permissionsGetResource',
        resourceName as any,
        resourceKey as any,
      ]);
  } else {
    return trimArrayEnd([
        'PermissionsClient',
        'permissionsGetResource',
        ...params
      ]);
  }
}
export function __permissionsGetResource(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.permissionsGetResource(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as string | undefined,axiosConfig    );
}

export function usePermissionsGetResourceQuery<TSelectData = Types.GetResourcePermissionListResultDto, TError = unknown>(dto: PermissionsGetResourcePermissionsQueryParameters, options?: Omit<UseQueryOptions<Types.GetResourcePermissionListResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param resourceName (optional) 
 * @param resourceKey (optional) 
 * @return OK
 */
export function usePermissionsGetResourceQuery<TSelectData = Types.GetResourcePermissionListResultDto, TError = unknown>(resourceName?: string | undefined, resourceKey?: string | undefined, options?: Omit<UseQueryOptions<Types.GetResourcePermissionListResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function usePermissionsGetResourceQuery<TSelectData = Types.GetResourcePermissionListResultDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetResourcePermissionListResultDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let resourceName: any = undefined;
  let resourceKey: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ resourceName, resourceKey,  } = params[0] as PermissionsGetResourcePermissionsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [resourceName, resourceKey, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetResourcePermissionListResultDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __permissionsGetResource(context, axiosConfig) : __permissionsGetResource,
    queryKey: permissionsGetResourceQueryKey(resourceName, resourceKey),
    ...permissionsGetResourceDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetResourcePermissionListResultDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param resourceName (optional) 
 * @param resourceKey (optional) 
 * @return OK
 */
export function setPermissionsGetResourceData(queryClient: QueryClient, updater: (data: Types.GetResourcePermissionListResultDto | undefined) => Types.GetResourcePermissionListResultDto, resourceName?: string | undefined, resourceKey?: string | undefined) {
  queryClient.setQueryData(permissionsGetResourceQueryKey(resourceName, resourceKey),
    updater
  );
}

/**
 * @param resourceName (optional) 
 * @param resourceKey (optional) 
 * @return OK
 */
export function setPermissionsGetResourceDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetResourcePermissionListResultDto | undefined) => Types.GetResourcePermissionListResultDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function permissionsUpdateResourceUrl(resourceName?: string | undefined, resourceKey?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/permission-management/permissions/resource?";
if (resourceName === null)
    throw new Error("The parameter 'resourceName' cannot be null.");
else if (resourceName !== undefined)
    url_ += "resourceName=" + encodeURIComponent("" + resourceName) + "&";
if (resourceKey === null)
    throw new Error("The parameter 'resourceKey' cannot be null.");
else if (resourceKey !== undefined)
    url_ += "resourceKey=" + encodeURIComponent("" + resourceKey) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function permissionsUpdateResourceMutationKey(resourceName?: string | undefined, resourceKey?: string | undefined): MutationKey {
  return trimArrayEnd([
      'PermissionsClient',
      'permissionsUpdateResource',
      resourceName as any,
      resourceKey as any,
    ]);
}

/**
 * @param resourceName (optional) 
 * @param resourceKey (optional) 
 * @param body (optional) 
 * @return OK
 */
export function usePermissionsUpdateResourceMutation<TContext>(resourceName?: string | undefined, resourceKey?: string | undefined, options?: Omit<UseMutationOptions<void, unknown, Types.UpdateResourcePermissionsDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.UpdateResourcePermissionsDto, TContext> {
  const key = permissionsUpdateResourceMutationKey(resourceName, resourceKey);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.UpdateResourcePermissionsDto) => Client.permissionsUpdateResource(resourceName, resourceKey, body),
    mutationKey: key,
  });
}
  
type PermissionsUpdateResource__MutationParameters = PermissionsUpdateResourcePermissionsQueryParameters & {
  body: Types.UpdateResourcePermissionsDto;
}

/**
 * @param resourceName (optional) 
 * @param resourceKey (optional) 
 * @param body (optional) 
 * @return OK
 */
export function usePermissionsUpdateResourceMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, PermissionsUpdateResource__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PermissionsUpdateResourcePermissionsQueryParameters}): UseMutationResult<void, unknown, PermissionsUpdateResource__MutationParameters, TContext> {
  const key = permissionsUpdateResourceMutationKey(options?.parameters?.resourceName!, options?.parameters?.resourceKey!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PermissionsUpdateResource__MutationParameters) => Client.permissionsUpdateResource(data.resourceName ?? options?.parameters?.resourceName!, data.resourceKey ?? options?.parameters?.resourceKey!, data.body),
  mutationKey: key,
});
}
  
export function permissionsDeleteResourceUrl(resourceName?: string | undefined, resourceKey?: string | undefined, providerName?: string | undefined, providerKey?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/permission-management/permissions/resource?";
if (resourceName === null)
    throw new Error("The parameter 'resourceName' cannot be null.");
else if (resourceName !== undefined)
    url_ += "resourceName=" + encodeURIComponent("" + resourceName) + "&";
if (resourceKey === null)
    throw new Error("The parameter 'resourceKey' cannot be null.");
else if (resourceKey !== undefined)
    url_ += "resourceKey=" + encodeURIComponent("" + resourceKey) + "&";
if (providerName === null)
    throw new Error("The parameter 'providerName' cannot be null.");
else if (providerName !== undefined)
    url_ += "providerName=" + encodeURIComponent("" + providerName) + "&";
if (providerKey === null)
    throw new Error("The parameter 'providerKey' cannot be null.");
else if (providerKey !== undefined)
    url_ += "providerKey=" + encodeURIComponent("" + providerKey) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function permissionsDeleteResourceMutationKey(resourceName?: string | undefined, resourceKey?: string | undefined, providerName?: string | undefined, providerKey?: string | undefined): MutationKey {
  return trimArrayEnd([
      'PermissionsClient',
      'permissionsDeleteResource',
      resourceName as any,
      resourceKey as any,
      providerName as any,
      providerKey as any,
    ]);
}

/**
 * @param resourceName (optional) 
 * @param resourceKey (optional) 
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @return OK
 */
export function usePermissionsDeleteResourceMutation<TContext>(resourceName?: string | undefined, resourceKey?: string | undefined, providerName?: string | undefined, providerKey?: string | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = permissionsDeleteResourceMutationKey(resourceName, resourceKey, providerName, providerKey);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.permissionsDeleteResource(resourceName, resourceKey, providerName, providerKey),
    mutationKey: key,
  });
}
  
type PermissionsDeleteResource__MutationParameters = PermissionsDeleteResourcePermissionsQueryParameters

/**
 * @param resourceName (optional) 
 * @param resourceKey (optional) 
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @return OK
 */
export function usePermissionsDeleteResourceMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, PermissionsDeleteResource__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PermissionsDeleteResourcePermissionsQueryParameters}): UseMutationResult<void, unknown, PermissionsDeleteResource__MutationParameters, TContext> {
  const key = permissionsDeleteResourceMutationKey(options?.parameters?.resourceName!, options?.parameters?.resourceKey!, options?.parameters?.providerName!, options?.parameters?.providerKey!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PermissionsDeleteResource__MutationParameters) => Client.permissionsDeleteResource(data.resourceName ?? options?.parameters?.resourceName!, data.resourceKey ?? options?.parameters?.resourceKey!, data.providerName ?? options?.parameters?.providerName!, data.providerKey ?? options?.parameters?.providerKey!),
  mutationKey: key,
});
}
  
export function permissionsGetResourceByProviderUrl(resourceName?: string | undefined, resourceKey?: string | undefined, providerName?: string | undefined, providerKey?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/permission-management/permissions/resource/by-provider?";
if (resourceName === null)
    throw new Error("The parameter 'resourceName' cannot be null.");
else if (resourceName !== undefined)
    url_ += "resourceName=" + encodeURIComponent("" + resourceName) + "&";
if (resourceKey === null)
    throw new Error("The parameter 'resourceKey' cannot be null.");
else if (resourceKey !== undefined)
    url_ += "resourceKey=" + encodeURIComponent("" + resourceKey) + "&";
if (providerName === null)
    throw new Error("The parameter 'providerName' cannot be null.");
else if (providerName !== undefined)
    url_ += "providerName=" + encodeURIComponent("" + providerName) + "&";
if (providerKey === null)
    throw new Error("The parameter 'providerKey' cannot be null.");
else if (providerKey !== undefined)
    url_ += "providerKey=" + encodeURIComponent("" + providerKey) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let permissionsGetResourceByProviderDefaultOptions: Omit<UseQueryOptions<Types.GetResourcePermissionWithProviderListResultDto, unknown, Types.GetResourcePermissionWithProviderListResultDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetResourcePermissionWithProviderListResultDto, unknown, Types.GetResourcePermissionWithProviderListResultDto>, 'queryFn'>> = {
};
export function getPermissionsGetResourceByProviderDefaultOptions() {
  return permissionsGetResourceByProviderDefaultOptions;
};
export function setPermissionsGetResourceByProviderDefaultOptions(options: typeof permissionsGetResourceByProviderDefaultOptions) {
  permissionsGetResourceByProviderDefaultOptions = options;
}

export function permissionsGetResourceByProviderQueryKey(dto: PermissionsGetResourceByProviderPermissionsQueryParameters): QueryKey;
export function permissionsGetResourceByProviderQueryKey(resourceName?: string | undefined, resourceKey?: string | undefined, providerName?: string | undefined, providerKey?: string | undefined): QueryKey;
export function permissionsGetResourceByProviderQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { resourceName, resourceKey, providerName, providerKey,  } = params[0] as PermissionsGetResourceByProviderPermissionsQueryParameters;

    return trimArrayEnd([
        'PermissionsClient',
        'permissionsGetResourceByProvider',
        resourceName as any,
        resourceKey as any,
        providerName as any,
        providerKey as any,
      ]);
  } else {
    return trimArrayEnd([
        'PermissionsClient',
        'permissionsGetResourceByProvider',
        ...params
      ]);
  }
}
export function __permissionsGetResourceByProvider(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.permissionsGetResourceByProvider(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as string | undefined,       context.queryKey[4] as string | undefined,       context.queryKey[5] as string | undefined,axiosConfig    );
}

export function usePermissionsGetResourceByProviderQuery<TSelectData = Types.GetResourcePermissionWithProviderListResultDto, TError = unknown>(dto: PermissionsGetResourceByProviderPermissionsQueryParameters, options?: Omit<UseQueryOptions<Types.GetResourcePermissionWithProviderListResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param resourceName (optional) 
 * @param resourceKey (optional) 
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @return OK
 */
export function usePermissionsGetResourceByProviderQuery<TSelectData = Types.GetResourcePermissionWithProviderListResultDto, TError = unknown>(resourceName?: string | undefined, resourceKey?: string | undefined, providerName?: string | undefined, providerKey?: string | undefined, options?: Omit<UseQueryOptions<Types.GetResourcePermissionWithProviderListResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function usePermissionsGetResourceByProviderQuery<TSelectData = Types.GetResourcePermissionWithProviderListResultDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetResourcePermissionWithProviderListResultDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let resourceName: any = undefined;
  let resourceKey: any = undefined;
  let providerName: any = undefined;
  let providerKey: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ resourceName, resourceKey, providerName, providerKey,  } = params[0] as PermissionsGetResourceByProviderPermissionsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [resourceName, resourceKey, providerName, providerKey, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetResourcePermissionWithProviderListResultDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __permissionsGetResourceByProvider(context, axiosConfig) : __permissionsGetResourceByProvider,
    queryKey: permissionsGetResourceByProviderQueryKey(resourceName, resourceKey, providerName, providerKey),
    ...permissionsGetResourceByProviderDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetResourcePermissionWithProviderListResultDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param resourceName (optional) 
 * @param resourceKey (optional) 
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @return OK
 */
export function setPermissionsGetResourceByProviderData(queryClient: QueryClient, updater: (data: Types.GetResourcePermissionWithProviderListResultDto | undefined) => Types.GetResourcePermissionWithProviderListResultDto, resourceName?: string | undefined, resourceKey?: string | undefined, providerName?: string | undefined, providerKey?: string | undefined) {
  queryClient.setQueryData(permissionsGetResourceByProviderQueryKey(resourceName, resourceKey, providerName, providerKey),
    updater
  );
}

/**
 * @param resourceName (optional) 
 * @param resourceKey (optional) 
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @return OK
 */
export function setPermissionsGetResourceByProviderDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetResourcePermissionWithProviderListResultDto | undefined) => Types.GetResourcePermissionWithProviderListResultDto) {
  queryClient.setQueryData(queryKey, updater);
}